import React from 'react';

import { Skeleton } from '@mui/material';
import styled from 'styled-components';

const PaddedSkeleton = styled(Skeleton)`
    margin: 0.5rem 0;
`;

const Spacer = styled.div`
    margin: 2rem;
`;

export interface UsersTableLoadingProps {}

const UsersTableLoading: React.FC<UsersTableLoadingProps> = () => (
    <>
        <Spacer />
        <PaddedSkeleton height={35} />
        <PaddedSkeleton height={35} />
        <PaddedSkeleton height={35} />
        <PaddedSkeleton height={35} />
        <PaddedSkeleton height={35} />
        <Spacer />
    </>
);

export default UsersTableLoading;
